import React, { Component } from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Checkbox } from "@progress/kendo-react-inputs";
import { DropDownList } from "@progress/kendo-react-dropdowns";

class Page1 extends Component {
	render() {
		return (
			<div className="d-flex flex-column h-100">
				<div className="flex-grow-1">
					<Checkbox
						label="Table Page"
						name="shouldCreateTable"
						onChange={this.handleCheckBox}
						checked={this.props.entity.shouldCreateTable}
						data-key={this.props.entity.id}
					/>
					<div className="form-label d-block py-1">This page allows user to review multiple records in a Table View</div>
					<Checkbox
						label="Split View Page"
						name="shouldCreateSplitView"
						onChange={this.handleCheckBox}
						checked={this.props.entity.shouldCreateSplitView}
						data-key={this.props.entity.id}
					/>
					<div className="form-label d-block py-1">This page allows user to review multiple records in a Split View</div>

					<Checkbox
						label="Cards Page"
						name="shouldCreateCards"
						onChange={this.handleCheckBox}
						checked={this.props.entity.shouldCreateCards}
						data-key={this.props.entity.id}
					/>
					<div className="form-label d-block py-1">This page allows user to review multiple records in a Cards View</div>

					<div className="form-label d-block py-1">Default Menu Item Page</div>
					<DropDownList
						data-key={this.props.entity.id}
						value={this.props.entity.defaultMenuItemPageType}
						name="defaultMenuItemPageType"
						data={this.getDefaultPageTypeOptions()}
						defaultValue={this.getDefaultPageTypeOptions()[0]}
						onChange={this.props.handleDropDrown}
					/>
				</div>
				<div className="d-flex justify-content-between mt-3">
					<button onClick={this.props.handleNext} className="btn btn-secondary mr-5 ms-1">
						Next <i className="fas fa-chevron-right mx-1"></i>
					</button>
					<button onClick={this.props.saveChanges} className="btn btn-primary">
						Save
					</button>
				</div>
			</div>
		);
	}

	handleCheckBox = (e) => {
		this.props.handleCheckBox(e);
		if (!this.props.entity.shouldCreateTable) {
			if (this.props.entity.shouldCreateCards) {
				this.props.handleDropDrown({ target: { props: { "data-key": this.props.entity.id }, name: "defaultMenuItemPageType", value: "Cards" } });
			} else if (this.props.entity.shouldCreateSplitView) {
				this.props.handleDropDrown({ target: { props: { "data-key": this.props.entity.id }, name: "defaultMenuItemPageType", value: "Split View" } });
			} else {
				this.props.handleDropDrown({ target: { props: { "data-key": this.props.entity.id }, name: "defaultMenuItemPageType", value: "" } });
			}
		} else if (!this.props.entity.shouldCreateCards && this.props.entity.defaultMenuItemPageType === "Cards") {
			if (this.props.entity.shouldCreateTable) {
				this.props.handleDropDrown({ target: { props: { "data-key": this.props.entity.id }, name: "defaultMenuItemPageType", value: "Table" } });
			} else if (this.props.entity.shouldCreateSplitView) {
				this.props.handleDropDrown({ target: { props: { "data-key": this.props.entity.id }, name: "defaultMenuItemPageType", value: "Split View" } });
			} else {
				this.props.handleDropDrown({ target: { props: { "data-key": this.props.entity.id }, name: "defaultMenuItemPageType", value: "" } });
			}
		} else if (!this.props.entity.shouldCreateSplitView && this.props.entity.defaultMenuItemPageType === "Cards") {
			if (this.props.entity.shouldCreateTable) {
				this.props.handleDropDrown({ target: { props: { "data-key": this.props.entity.id }, name: "defaultMenuItemPageType", value: "Table" } });
			} else if (this.props.entity.shouldCreateCards) {
				this.props.handleDropDrown({ target: { props: { "data-key": this.props.entity.id }, name: "defaultMenuItemPageType", value: "Cards" } });
			} else {
				this.props.handleDropDrown({ target: { props: { "data-key": this.props.entity.id }, name: "defaultMenuItemPageType", value: "" } });
			}
		}
	};

	getDefaultPageTypeOptions = () => {
		let options = [];

		if (this.props.entity.shouldCreateTable) {
			options.push("Table");
		}

		if (this.props.entity.shouldCreateCards) {
			options.push("Cards");
		}

		if (this.props.entity.shouldCreateSplitView) {
			options.push("Split View");
		}

		return options;
	};
}

class Page2 extends Component {
	detailsViewStyleOption = ["Layout 1", "Layout 2"];

	componentDidMount() {
		let { entity } = this.props;
		if (entity.isNotLinkedToOtherEntity) {
			this.detailsViewStyleOption = ["Layout 2"];
			this.forceUpdate();
		}
	}

	render() {
		return (
			<div className="d-flex flex-column h-100">
				<div className="flex-grow-1">
					<Checkbox
						label="Details View Page"
						name="shouldCreateDetailsView"
						onChange={this.props.handleCheckBox}
						checked={this.props.entity.shouldCreateDetailsView}
						data-key={this.props.entity.id}
					/>
					<div className="form-label d-block py-1">This page allows user to review details of a single record</div>

					<DropDownList
						data-key={this.props.entity.id}
						name="detailsViewStyle"
						data={this.detailsViewStyleOption}
						value={this.props.entity.detailsViewStyle}
						onChange={this.props.handleDropDrown}
					/>
					<br />
					<br />

					<Checkbox
						label="New Record Page"
						name="shouldCreateNewRecord"
						onChange={this.props.handleCheckBox}
						checked={this.props.entity.shouldCreateNewRecord}
						data-key={this.props.entity.id}
					/>
					<div className="form-label d-block py-1">This page allows user to add a new record</div>
					<br />

					<Checkbox
						label="Edit Record Page"
						name="shouldCreateEditRecord"
						onChange={this.props.handleCheckBox}
						checked={this.props.entity.shouldCreateEditRecord}
						data-key={this.props.entity.id}
					/>
					<div className="form-label d-block py-1">This page allows user to edit record</div>
					<br />

					<br style={{ clear: "both" }} />
				</div>
				<div className="d-flex justify-content-between">
					<div>
						<button onClick={this.props.handlePrevious} className="btn btn-secondary">
							<i className="fas fa-chevron-left mx-1"></i>Previous
						</button>
						<button onClick={this.props.handleNext} className="btn btn-secondary mr-5 ms-1">
							Next <i className="fas fa-chevron-right mx-1"></i>
						</button>
					</div>
					<button onClick={this.props.saveChanges} className="btn btn-primary">
						Save
					</button>
				</div>
			</div>
		);
	}
}

class Page3 extends Component {
	render() {
		return (
			<div className="d-flex flex-column h-100">
				<div className="flex-grow-1">
					<big className="d-block">Link Record Reference Pages</big>
					This page allows user to review linked record(s) in a Cards View
					<hr className="my-3" />
					<div className="form-label d-block py-1">Page Style</div>
					<DropDownList
						data-key={this.props.entity.id}
						name="linkRecordReferencePageStyle"
						data={["Table", "Cards"]}
						value={this.props.entity.linkRecordReferencePageStyle}
						onChange={this.props.handleDropDrown}
					/>
					<br />
					<Checkbox
						name="shouldCreateReference"
						label="Linked Record All Records Pages"
						onChange={this.props.handleCheckBox}
						checked={this.props.shouldCreateReference}
						disabled={this.props.entity.areLinkOptionsDisabled}
						data-key={this.props.entity.id}
					/>
					<div className="form-label">This page allows user to review details of linked record</div>
					<br />
					{this.props.entity.linkRecordReferencePageStyle.localeCompare("Cards") === 0 && (
						<>
							{/* <DropDownList
								data-key={this.props.entity.id}
								name="linkRecordDetailsPageStyle"
								data={[ "Table" ]}
								disabled={true}
								value={this.props.entity.linkRecordDetailsPageStyle}
								onChange={this.props.handleDropDrown} /> */}
							<Checkbox
								label="PageStyle"
								name="shouldCreateLinkRecordDetails"
								onChange={this.props.handleCheckBox}
								checked={this.props.shouldCreateLinkRecordDetails}
								disabled={this.props.entity.areLinkOptionsDisabled}
								data-key={this.props.entity.id}
							/>
							<br />
						</>
					)}
					<br />
					<Checkbox
						label="Link Record Page"
						name="shouldCreateLinkRecord"
						onChange={this.props.handleCheckBox}
						checked={this.props.shouldCreateLinkRecord}
						disabled={this.props.entity.areLinkOptionsDisabled}
						data-key={this.props.entity.id}
					/>
					<div className="form-label d-block py-1">This page allows user to link records</div>
				</div>

				<div className="d-flex justify-content-between">
					<div>
						<button onClick={this.props.handlePrevious} className="btn btn-secondary">
							<i className="fas fa-chevron-left mx-1"></i>Previous
						</button>
						<button onClick={this.props.handleNext} className="btn btn-secondary mr-5 ms-1">
							Next <i className="fas fa-chevron-right mx-1"></i>
						</button>
					</div>
					<button onClick={this.props.saveChanges} className="btn btn-primary">
						Save
					</button>
				</div>
			</div>
		);
	}
}

class Page4 extends Component {
	render() {
		return (
			<div className="d-flex flex-column h-100">
				<div className="flex-grow-1">
					<Checkbox
						label="Show in Menu Items"
						checked={this.props.showInMenuItem}
						disabled={this.props.entity.primary === "false"}
						data-key={this.props.entity.id}
					/>
				</div>
				<div className="d-flex justify-content-between">
					<div>
						<button onClick={this.props.handlePrevious} className="btn btn-secondary">
							<i className="fas fa-chevron-left mx-1"></i>Previous
						</button>
					</div>
					<button onClick={this.props.saveChanges} className="btn btn-primary">
						Save
					</button>
				</div>
			</div>
		);
	}
}

export class EntityConfigurationModal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			currentPage: 0,
		};
	}

	render() {
		if (!this.props.isEntityConfigurationModalVisible) {
			return null;
		}

		const { entityName } = this.props.entity;
		const { currentPage } = this.state;

		let page, title;

		if (currentPage === 0) {
			page = (
				<Page1
					handleNext={this.handleNext}
					handlePrevious={this.handlePrevious}
					entity={this.props.entity}
					handleDropDrown={this.props.handleDropDrown}
					handleCheckBox={this.props.handleCheckBox}
					saveChanges={this.saveChanges}
				/>
			);
			title = " - Multiple Record Page Selection";
		} else if (currentPage === 1) {
			page = (
				<Page2
					handleNext={this.handleNext}
					handlePrevious={this.handlePrevious}
					entity={this.props.entity}
					handleCheckBox={this.props.handleCheckBox}
					handleDropDrown={this.props.handleDropDrown}
					saveChanges={this.saveChanges}
				/>
			);
			title = " - Single Record Page Selection";
		} else if (currentPage === 2) {
			page = (
				<Page3
					handleNext={this.handleNext}
					handlePrevious={this.handlePrevious}
					entity={this.props.entity}
					handleCheckBox={this.props.handleCheckBox}
					handleDropDrown={this.props.handleDropDrown}
					saveChanges={this.saveChanges}
				/>
			);
			title = " - Linked Record Pages";
		} else {
			page = (
				<Page4
					handlePrevious={this.handlePrevious}
					entity={this.props.entity}
					handleCheckBox={this.props.handleCheckBox}
					toggleEntityConfigurationModal={this.toggleEntityConfigurationModal}
					saveChanges={this.saveChanges}
				/>
			);
			title = " - Linked Record Pages";
		}

		return (
			<Dialog width={600} height={450} title={entityName + title} onClose={this.toggleEntityConfigurationModal}>
				{page}
			</Dialog>
		);
	}

	handleNext = () => {
		this.setState({ currentPage: this.state.currentPage + 1 });
	};

	handlePrevious = () => {
		this.setState({ currentPage: this.state.currentPage - 1 });
	};

	toggleEntityConfigurationModal = (e) => {
		this.setState({ currentPage: 0 });
		this.props.toggleEntityConfigurationModal(e);
	};

	saveChanges = (e) => {

		if (this.state.currentPage === 3) {
			this.toggleEntityConfigurationModal(e);
		}
		this.props.saveChanges(e);
	};
}
